import React, { useState, useEffect } from "react";
import { constants } from "../constants";
import { useLocation, useNavigate } from "react-router-dom";
import Utils from "../helpers/utils";

const navLinks = [
  { label: "Home", navigateTo: constants.route.home },
  { label: "About", navigateTo: constants.route.about },
  { label: "Portfolio", navigateTo: constants.route.portfolio },
  { label: "Packages", navigateTo: constants.route.packages },
  { label: "Video", navigateTo: constants.route.video },
  { label: "Contact", navigateTo: constants.route.contact },
];

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isShrunk, setIsShrunk] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsShrunk(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div
        className={`fixed top-0 w-full z-50 transition-all duration-300 ${
          isShrunk ? "h-16 shadow-md" : "h-24"
        } bg-white py-4 px-6 sm:px-8 md:px-12 lg:px-16 flex items-center justify-between`}
      >
        <div className="xl:w-52 lg:w-40 md:w-52 sm:w-40 flex justify-center items-center">
          <img
            src={Utils.ImagePath("/images/logo.png")}
            alt="Logo"
            className={`cursor-pointer transition-all duration-300 ${
              isShrunk ? "xl:w-40 lg:w-32 md:w-40 sm:w-32" : "w-full"
            } h-auto`}
            onClick={() => navigate(constants.route.home)}
          />
        </div>
        <nav className="hidden lg:flex xl:space-x-16 lg:space-x-10 md:space-x-0 sm:space-x-0 px-6">
          {navLinks.map((link, index) => (
            <div key={index} className="relative group">
              <a
                href={link.navigateTo}
                className="text-darkLiver font-medium text-xs uppercase tracking-[.3em]"
              >
                {link.label}
              </a>
              <span
                className={`absolute left-0 bottom-0 h-px bg-darkLiver mt-2 transition-all duration-300 ${
                  location.pathname.includes(link.navigateTo)
                    ? "w-full"
                    : "w-0 group-hover:w-full"
                }`}
              ></span>
            </div>
          ))}
        </nav>
        <i
          className="fa-solid fa-bars cursor-pointer flex xl:w-52 lg:w-40 md:w-52 sm:w-40  justify-end"
          onClick={() => setIsDrawerOpen(true)}
        />
      </div>
      <div
        className={`fixed top-0 right-0 h-full sm:w-56 md:w-96 lg:w-96 z-50 bg-darkLiver shadow-lg transform transition-transform duration-300 ease-in-out ${
          isDrawerOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <i
          className="fa-solid fa-times cursor-pointer p-4 text-white text-xl flex justify-end items-center"
          onClick={() => setIsDrawerOpen(false)}
        />
        <div className="hidden lg:flex flex-col">
          <div className="text-md font-thin text-white px-16 text-center">
            360 Baby Photography specializes in capturing the most precious
            milestones of your little one’s journey, from the glowing beauty of
            maternity to the playful charm of toddlers. We create timeless
            memories with soft and dreamy newborn portraits, energetic and fun
            toddler sessions, and joyful cake smash celebrations. Our outdoor
            shoots embrace natural beauty, while lifestyle sessions offer
            candid, heartwarming moments. With creativity and care, we ensure
            every photo reflects love, emotion, and the magic of childhood.
          </div>
          <div className="uppercase font-cormorantGaramond tracking-[.15em] text-xl text-center mt-10 mb-5 text-white">
            Follow Us
          </div>
          <div className="flex flex-row justify-center items-center space-x-3 text-xl text-center text-white">
            <i
              className="fa-brands fa-facebook-f cursor-pointer"
              onClick={() =>
                window.open(
                  "https://www.facebook.com/people/360BabyPhotography/100082413384778/",
                  "_blank"
                )
              }
            />
            <div className="h-px w-6 bg-chineseSilver" />
            <i
              className="fa-brands fa-instagram cursor-pointer"
              onClick={() =>
                window.open(
                  "https://www.instagram.com/360babyphotography__/?hl=en",
                  "_blank"
                )
              }
            />
            <div className="h-px w-6 bg-chineseSilver" />
            <i
              className="fa-brands fa-whatsapp cursor-pointer"
              onClick={() =>
                window.open(
                  "https://api.whatsapp.com/send/?phone=%2B919297929272&text&type=phone_number&app_absent=0",
                  "_blank"
                )
              }
            />
          </div>
        </div>
        <nav className="flex flex-col p-6 space-y-6 lg:hidden">
          {navLinks.map((link, index) => (
            <a
              key={index}
              href={link.navigateTo}
              className="text-white text-sm font-medium uppercase tracking-[.15em] text-center"
              onClick={() => setIsDrawerOpen(false)}
            >
              {link.label}
            </a>
          ))}
        </nav>
      </div>
      {isDrawerOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsDrawerOpen(false)}
        />
      )}
    </>
  );
};

export default React.memo(Navbar);
